import { IFinoVersion } from '@fino-ui/common';

/**
 * Generated `version.ts` file.
 *
 * THIS CODE IS AUTOMATICALLY GENERATED.
 *
 * Generated by @fino-ui/cli@2.4.7.
 * To regenerate, run `npx -p @fino-ui/cli fino-ui version`.
 */
export const Version: IFinoVersion = {
  version: '1.0.0',
  revision: 'e71a8b3',
  branch: 'master',
  env: 'ci',
};
